// themes.js 切换颜色
import 'mutationobserver-shim'
import cssVars from 'css-vars-ponyfill'

const createLink = (() => {
  let $link = null
  return () => {
    if ($link) {
      return $link
    }
    $link = document.createElement('link')
    $link.rel = 'stylesheet'
    $link.type = 'text/css'
    document.querySelector('head').appendChild($link)
    return $link
  }
})()

/**
 * 主题切换函数
 * 根据颜色加载相对应颜色的css
 * @param {string} theme - 主题名称, 默认default
 * @return {string} 主题名称
 */
const themes = (theme) => {
  const $link = createLink()
  $link.href = `./themes/${theme}.css`
  cssVars({
    watch: false
  })
  setTimeout(function() {
    cssVars({
      watch: true
    })
  }, 0)
  localStorage.setItem('theme', theme)
  return theme
}

export default themes
